import { BhEmptyMessageComponent } from './bh-empty-message.component';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [
    BhEmptyMessageComponent
    ],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
  ],
  exports: [
    BhEmptyMessageComponent
  ]
})
export class BhEmptyMessageComponentModule { }
